import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import ListIcon from "../../icons/ListIcon";
import AnalyzingIcon from "../../icons/AnalyzingIcon";
import ClockIcon from "../../icons/ClockIcon";

export const TABS = {
  GERAL: "geral",
  COLETA_TARDIA: "coleta-tardia",
  EM_ANALISE: "em-analise",
  TRES_DIAS_PARADO: "tres-dias-parado",
};

export const ABAS = {
  COLETA_TARDIA: "COLETA_TARDIA",
  EM_ANALISE: "EM_ANALISE",
  PARADO_3_DIAS: "PARADO_3_DIAS",
};

export const readyToGoTabs = [
  {
    key: TABS.GERAL,
    label: "GERAL",
    icon: ListIcon,
  },
  {
    key: TABS.COLETA_TARDIA,
    label: "COLETA TARDIA",
    icon: ReportProblemIcon,
    countKey: "coletaTardia",
    disabled: false,
  },
  {
    key: TABS.EM_ANALISE,
    label: "EM ANÁLISE",
    icon: AnalyzingIcon,
    countKey: "emAnalise",
    disabled: false,
  },
  {
    key: TABS.TRES_DIAS_PARADO,
    label: "+3 DIAS PARADO",
    icon: ClockIcon,
    countKey: "parado3Dias",
    disabled: false,
  },
];
